import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import ProposalSubmission from '../../components/ProposalSubmission.tsx';

const Proposals: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Proposals</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <ProposalSubmission />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Proposals;